import {createAction} from '@reduxjs/toolkit';

import {HostCartType} from 'hostApplicationStoreType';

/**
 * Set initial data to reducers from host store
 */
export const setDataFromHostStore = createAction<HostCartType>('SET_DATA_FROM_HOST_STORE');

/**
 * Get cart quote saga
 */
export const getCartQuoteSaga = createAction('CART@QUOTE_SAGA');

/**
 * Action which means that product was added
 */
export const productAdded = createAction('CART@PRODUCT_ADDED');

/**
 * Action which means that cart was updated
 */
export const cartUpdated = createAction('CART@UPDATED');
